import { isDevelopment } from 'env';
import React from 'react';

const AcceptableDocsLink = ({
  children,
  style,
}: {
  children?: React.ReactNode;
  style?: React.CSSProperties;
}) => (
  <a
    style={style}
    href={`${process.env.PUBLIC_URL}${
      isDevelopment ? '/' : '/static/'
    }Shared%20Housing%20Acceptable%20ID%20Documents.pdf`}
    target='_blank'
    rel='noreferrer'
  >
    {children || 'Approved ID Documents'}
  </a>
);

export default AcceptableDocsLink;
